import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import axios from 'axios';
import {
    UsersRound,
    Layers,
    ContactRound,
    BellRing,
    FileText,
    UserRound,
    Star,
    House,
    LogOut
} from "lucide-react";
import { useSidebar } from './SidebarContext';

const Sidebar = ({ user }) => {
    const [categories, setCategories] = useState([]);
    const { isSidebarExpanded } = useSidebar();

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get('categorie_cvs');
                if (response.status === 200) {
                    setCategories(response.data);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchCategories();
    }, []);

    const handleClickDecon = () => {
        localStorage.clear();
        window.location.replace('/cvtheque');
    };

    const userMenu = localStorage.user_token && (
        user.role === 'Administrateur' ? (
            <>
                <SidebarItem to="/utilisateurs" icon={<UsersRound size={20} strokeWidth={1.5} />} label="Utilisateurs" />
                <SidebarItem to="/categories" icon={<Layers size={20} strokeWidth={1.5} />} label="Liste des Categories" />
                <SidebarItem to="/table" icon={<ContactRound size={20} strokeWidth={1.5} />} label="Candidat" />
                <SidebarItem to="/notifications" icon={<BellRing size={20} strokeWidth={1.5} />} label="Notifications" />
                <SidebarItem to="/cv" icon={<FileText size={20} strokeWidth={1.5} />} label="Tous les CV" />
            </>
        ) : (
            <>
                <SidebarItem to="/profile" icon={<UserRound size={20} strokeWidth={1.5} />} label="Profile" />
                <SidebarItem to="/notification" icon={<BellRing size={20} strokeWidth={1.5} />} label="Notifications" />
                <SidebarItem to="/favoris" icon={<Star size={20} strokeWidth={1.5} />} label="Favoris" />
                <hr />
                {categories.map(categorie => (
                    <GetCategoryCvcount key={categorie.id} dId={categorie.id}>
                        {count => count && (
                            <SidebarItem to={`/candidats/${categorie.id}`} icon={<Layers size={20} strokeWidth={1.5} />} label={categorie.categorie} count={count} />
                        )}
                    </GetCategoryCvcount>
                ))}
            </>
        )
    );

    return (
        localStorage.user_token && (
            <div className={`adminx-sidebar expand-hover push ${isSidebarExpanded ? 'in' : ''}`}>
                <ul className="sidebar-nav">
                    <SidebarItem to="/" icon={<House size={20} strokeWidth={1.5} />} label="Tableau de bord" />
                    {userMenu}
                    <SidebarItem icon={<LogOut size={20} strokeWidth={1.5} />} label="Deconnexion" onClick={handleClickDecon} />
                </ul>
            </div>
        )
    );
};

const SidebarItem = ({ to, icon, label, count, onClick }) => {
    return (
        <li className="sidebar-nav-item">
            {to ? (
                <NavLink to={to} className="sidebar-nav-link" style={{ paddingTop: '15px' }}>
                    <div className="sidebar-nav-icon">
                        {icon}
                    </div>
                    <span className="sidebar-nav-name">{label} {count}</span>
                </NavLink>
            ) : (
                <a href="#" className="sidebar-nav-link" onClick={onClick} style={{ paddingTop: '15px' }}>
                    <div className="sidebar-nav-icon">
                        {icon}
                    </div>
                    <span className="sidebar-nav-name">{label}</span>
                </a>
            )}
        </li>
    );
};

const GetCategoryCvcount = ({ dId, children }) => {
    const [cvCounter, setCvCounter] = useState(null);

    useEffect(() => {
        const fetchCvCount = async () => {
            try {
                const response = await axios.get(`categorie_cvs/${dId}`);
                if (response.status === 200) {
                    setCvCounter(response.data.counter);
                }
            } catch (error) {
                console.error('Error fetching category CV count:', error);
            }
        };
        fetchCvCount();
    }, [dId]);

    if (cvCounter === 0) return children(null);
    return children(<b>({cvCounter})</b>);
};

export default Sidebar;
